export const lightTheme = {
  color: {
    black: '#000000',
    mainBG: '#FFFFFF',
    menuBG: '#F8F8F8',
    openMobileMenu: '#00000033',
    accent: '#F87719',
    title: '#111111',
    secondaryText: '#F8F8F8',
    navLinks: '#595959',
    logo: '#282828',
    form: '#595959',
    white: '#FFFFFF',
    accordionPanel: '#595959',
    accordionColor: '#FFFFFF',
    linear:
      'linear-gradient( 141.22deg,#f84119 9.4%,rgba(248, 159, 25, 0.68) 91.91%)',
  },
};

export const darkTheme = {
  color: {
    black: '#000000',
    menuBG: '#171717',
    openMobileMenu: '#FFFFFF33',
    mainBG: '#111111',
    accent: '#F87719',
    title: '#FFFFFF',
    secondaryText: '#F8F8F8',
    navLinks: '#B7B7B7',
    logo: '#FFFFFF',
    form: '#B7B7B7',
    white: '#FFFFFF',
    accordionPanel: '#FFFFFF',
    accordionColor: '#595959',
    linear:
      'linear-gradient( 141.22deg,#f84119 9.4%,rgba(248, 159, 25, 0.68) 91.91%)',
  },
};
